import moment from 'moment'
import React from 'react';
import visbook from 'api/visbook';

import { connect } from 'react-redux';
import { emptyReservations, updateReservation } from 'store';

const maxReservationTime = 60 * 20; // 20 minutes

class ReservationKeepAlive extends React.Component {
    constructor(props) {
        super(props);

        this.pingInterval = null;
        this.pingReservations = this.pingReservations.bind(this);
    }

    componentDidMount() {
        this.pingInterval = setInterval(this.pingReservations, 60 * 1000);
        this.pingReservations();
    }

    componentWillUnmount() {
        clearInterval(this.pingInterval);
    }

    pingReservations() {
        let { reservations, firstReservationTime } = this.props.booking;

        firstReservationTime = moment(firstReservationTime);
        const currentTime = moment(new Date());
        const secondsSinceFirstReservation = currentTime.diff(firstReservationTime) / 1000;

        let parsedReservations = reservations.map(r => {
            return {
                reservationId: r.reservationId,
                encryptedCompanyId: r.encryptedCompanyId,
            }
        });

        if (parsedReservations.length > 0) {
            if(secondsSinceFirstReservation > maxReservationTime) {
                this.props.emptyReservations();
                return;
            }
            visbook.pingReservations(parsedReservations)
                .then(response => {
                    parsedReservations.forEach(r => this.props.updateReservation(r));
                })
                .catch(response => {
                    this.props.emptyReservations()
                })
        }
    }

    render() {
        return null
    }
}

const mapStateToProps = state => {
    return {
        booking: state.booking
    }
}

const actions = {
    updateReservation,
    emptyReservations,
}

export default connect(mapStateToProps, actions)(ReservationKeepAlive);
